import { render } from "./GeneratedViewPage.vue?vue&type=template&id=6732ebd9&scoped=true"
import script from "./GeneratedViewPage.vue?vue&type=script&lang=js"
export * from "./GeneratedViewPage.vue?vue&type=script&lang=js"

import "./GeneratedViewPage.vue?vue&type=style&index=0&id=6732ebd9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6732ebd9"]])

export default __exports__